import { useEffect } from "react";
import { trackScrollDepth } from "./eventHelpers";

const SCROLL_THRESHOLDS = [25, 50, 75, 90];

const getScrollPercent = () => {
  const doc = document.documentElement;
  const scrollTop = window.scrollY || doc.scrollTop || 0;
  const scrollHeight = doc.scrollHeight - doc.clientHeight;

  if (scrollHeight <= 0) {
    return 100;
  }

  return Math.min(100, Math.round((scrollTop / scrollHeight) * 100));
};

/**
 * Tracks overall page scroll depth at 25/50/75/90, once per threshold.
 */
export const useScrollDepthTracking = (thresholds = SCROLL_THRESHOLDS) => {
  useEffect(() => {
    if (typeof window === "undefined") {
      return undefined;
    }

    let ticking = false;

    const checkDepth = () => {
      const percent = getScrollPercent();
      thresholds.forEach((threshold) => {
        if (percent >= threshold) {
          trackScrollDepth(threshold);
        }
      });
      ticking = false;
    };

    const onScroll = () => {
      if (ticking) {
        return;
      }
      ticking = true;
      window.requestAnimationFrame(checkDepth);
    };

    // Capture already-scrolled state (e.g. restored scroll position).
    checkDepth();

    window.addEventListener("scroll", onScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", onScroll);
    };
  }, [thresholds]);
};
